<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="showPaymentTermsModal"
                   :data="model"
                   :title="$t('Payment Terms')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <input-widget :autofocus="true" ref="paymentTermsInput" :hint="true" :label="false" :model="model"
                    attribute="payment_terms" type="number"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import PaymentTermsForm from "@/modules/sales/PaymentTermsForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "PaymentTermsModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new PaymentTermsForm({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['togglePaymentTermsModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let response = await this.saveTermsPartialData({payment_terms: this.model.payment_terms});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          await this.togglePaymentTermsModal(false);
          this.$toast('success', this.$t('Payment terms were successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.model = new PaymentTermsForm({payment_terms: this.paymentTerms || this.defaultPaymentTerms});
      },
      onHidden() {
        this.model = new PaymentTermsForm();
        this.togglePaymentTermsModal(false);
      },
    },
    watch: {
      paymentTerms() {
        this.model = new PaymentTermsForm({payment_terms: this.paymentTerms});
      }
    },
    computed: {
      ...globalMapState(['defaultPaymentTerms']),
      ...mapState({
        showPaymentTermsModal: state => state.view.termsData.paymentTermsModal.show,
        paymentTerms: state => state.view.termsData.payment_terms
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

